import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as UngroupIcon } from 'assets/icons/toolbar/ungroup.svg';
import { unGroupSelectedWidgets, useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectActiveWidgets } from 'modules/Editor/store/widgetSelector';
import { useTranslation } from 'react-i18next';

import { BUTTON_SIZE, ICON_SIZE } from '../WidgetControl.config';

/**
 * GROUP CTRL
 * Note: currently only supports ungrouping. Hidden otherwise
 */
export const GroupControl = () => {
  const { t } = useTranslation('editor_toolbar');

  const activeWidgets = useAppSelector(selectActiveWidgets);
  const showGroupCtrl = !!activeWidgets[0].groupId;

  const dispatch = useAppDispatch();

  const onClick = () => {
    dispatch(unGroupSelectedWidgets(activeWidgets[0].groupId));
  };

  const unGroupText = t('group.ungroupCtrl');

  if (!showGroupCtrl) {
    return null;
  }

  return (
    <Tooltip hasArrow placement='top' label={unGroupText} bg='black'>
      <IconButton
        aria-label={unGroupText}
        width={`${BUTTON_SIZE}px`}
        height={`${BUTTON_SIZE}px`}
        icon={<UngroupIcon width={ICON_SIZE} height={ICON_SIZE} />}
        variant='icon-btn-widget-ctrl'
        isActive={true}
        onClick={onClick}
      />
    </Tooltip>
  );
};
